import { environment } from './environmentVariables'

export const isPasskeyEnabled = (): boolean => {
  try {
    if (environment !== 'production') {
      return true
    }
    return localStorage.getItem('enablePasskey') === 'true'
  } catch {
    return false
  }
}
